import { logger } from './logger'
import { fetchFromService } from '../utils/fetch'
import { merge } from 'lodash-es'
import { type ServiceEnvironment } from './get-url'

/**
 *
 * @param settings
 */
export async function loadSettingsFromDomain<T extends { env?: ServiceEnvironment, byDomain?: boolean }> (settings?: T): Promise<T> {
  if (settings?.byDomain === false) {
    return settings
  }

  const url = new URL(window.location.toString())
  const domain = url.hostname

  logger.debug('Loading settings from domain: ', domain)

  const data = await fetchFromService({
    service: 'content',
    path: `/embed/by-domain/${domain}`,
    env: settings?.env
  })

  logger.debug('Loaded settings from domain: ', data)

  return merge({}, settings, data)
}
